import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { header5, title } from 'styles/texts'
import { contactConsultant } from 'actions'
import {
  consultantFirstNameSelector,
  chatIdSelector,
  userTypeSelector,
} from 'selectors'
import { ADMIN, CUSTOMER, CONSULTANT } from 'userTypes'

import { Form, Field, Label, Textarea } from 'components/form'
import ButtonComponent from 'components/Button'

const Wrapper = styled.div`
  padding: 10%;
`

const Button = styled(ButtonComponent)`
  margin: 10px auto;
`

const Buttons = styled.div`
  display: flex;

  & > * {
    margin-right: 0;
    margin-left: 0;
  }

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`

const Heading = styled.div`
  ${header5};
`

const Text = styled.div`
  ${title};
  margin: 11px 0 60px;
`

const defaultMessage = userType => {
  switch (userType) {
    case CUSTOMER:
      return 'Hei! Er du interessert i å jobbe for meg?'
    case CONSULTANT:
    case ADMIN:
    default:
      return ''
  }
}

class ContactForm extends React.Component {
  state = {
    message: defaultMessage(this.props.userType),
  }

  submit = e => {
    e.preventDefault()
    this.props.contactConsultant(this.props.consultantId, this.state.message)
    this.setState({ done: true })
  }

  render() {
    return this.state.done ? (
      <Wrapper>
        <Heading>Takk!</Heading>
        <Text>
          {this.props.name} svarer deg plutselig. Ha det fint så lenge!
          <span role="img" aria-label="">
            👋
          </span>
        </Text>
        <Buttons>
          <Button secondary onClick={this.props.closeModal}>
            Fortsett søk
          </Button>
          <Button to={`/chat/${this.props.chatId}`}>Gå til chat</Button>
        </Buttons>
      </Wrapper>
    ) : (
      <Form onSubmit={this.submit}>
        <Field>
          <Label htmlFor="message">Melding</Label>
          <Textarea
            id="text"
            type="message"
            value={this.state.message}
            placeholder="Skriv en melding..."
            onChange={e => this.setState({ message: e.target.value })}
          />
        </Field>
        <Button type="submit">Send</Button>
      </Form>
    )
  }
}

const mapStateToProps = (state, { consultantId }) => ({
  consultantId,
  name: consultantFirstNameSelector(state, consultantId),
  chatId: chatIdSelector(state, consultantId),
  userType: userTypeSelector(state),
})

const mapDispatchToProps = { contactConsultant }

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm)



// WEBPACK FOOTER //
// ./src/components/ContactForm.js